import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon, type FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import type { MouseEvent, ReactNode } from "react";
import type { ITooltip } from "react-tooltip";
import CustomTooltipWrapper from "~/features/common/components/CustomTooltipWrapper/index";

export type IconAtomProps = FontAwesomeIconProps & {
  jsx?: ReactNode | null;
  icon: IconDefinition;
  content?: string;
  html?: string;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  place?: ITooltip["place"];
};

const Icon = (props: IconAtomProps) => {
  const { jsx, icon, content, html, onClick, place, ...otherProps } = props;

  return (
    <CustomTooltipWrapper content={content} jsx={jsx} html={html} place={place}>
      <FontAwesomeIcon icon={icon} onClick={onClick} {...otherProps} />
    </CustomTooltipWrapper>
  );
};

export default Icon;
